// SEO helpers: page-level meta + JSON-LD schema generation.
import { BRAND } from "./data";

export const SITE_URL = "https://www.ragi.online";

export function buildTitle(parts) {
  return [...parts.filter(Boolean), "Ragi"].join(" | ");
}

export function buildCanonical(pathname) {
  const clean = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${SITE_URL}${clean === "/" ? "/" : clean.replace(/\/$/, "")}`;
}

// Schemas
export function orgSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": `${SITE_URL}/#organization`,
    name: "Ragi",
    legalName: "Ragi Media",
    url: SITE_URL,
    logo: `${SITE_URL}/logo.png`,
    description:
      "Senior-led branding, digital and packaging design studio in Bengaluru, working with businesses worldwide.",
    email: BRAND.email,
    telephone: BRAND.phone,
    founder: { "@type": "Person", "name": "Abhijit J K" },
    foundingDate: "2010",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Bengaluru",
      addressRegion: "Karnataka",
      addressCountry: "IN",
    },
    areaServed: [
      "India", "United Arab Emirates", "Singapore",
      "United Kingdom", "United States",
    ],
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: buildCanonical(it.path),
    })),
  };
}

export function serviceSchema({ name, description, path, location }) {
  const provider = {
    "@type": "ProfessionalService",
    name: "Ragi",
    url: SITE_URL,
  };
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    description,
    url: buildCanonical(path),
    provider,
    serviceType: name,
  };
  if (location) {
    schema.areaServed = {
      "@type": "City",
      name: location.name,
      containedInPlace: { "@type": "Country", name: location.country },
    };
  }
  return schema;
}

export function localBusinessSchema(location) {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: `Ragi ${location.name}`,
    url: buildCanonical(`/locations/${location.slug}`),
    description: location.context,
    telephone: BRAND.phone,
    email: BRAND.email,
    address: {
      "@type": "PostalAddress",
      addressLocality: location.name,
      addressRegion: location.region,
      addressCountry: location.country,
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: location.lat,
      longitude: location.lng,
    },
    areaServed: location.name,
  };
}

export function faqSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
